import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';

type VimeoOEmbedResponse = {
  thumbnail_url?: string;
};

@Injectable({ providedIn: 'root' })
export class VideoThumbnailService {
  private readonly http = inject(HttpClient);
  private readonly vimeoCache = new Map<string, Observable<string | null>>();

  getVimeoThumbnail(videoUrl: string): Observable<string | null> {
    const cached = this.vimeoCache.get(videoUrl);
    if (cached) return cached;

    const params = new HttpParams()
      .set('url', videoUrl)
      .set('width', '640');

    const request = this.http
      .get<VimeoOEmbedResponse>('https://vimeo.com/api/oembed.json', { params })
      .pipe(
        map((response) => response.thumbnail_url || null),
        catchError(() => of(null)),
        shareReplay({ bufferSize: 1, refCount: false }),
      );

    this.vimeoCache.set(videoUrl, request);
    return request;
  }
}
